module.exports = __webpack_public_path__ + "static/media/icon-circle-cyan-full.b870cdf4.svg";